import services from 'services/services';
import * as types from '../types';

// Import helpers
import { checkFetchErrors } from '../helpers_actions/convert_helpers';

// ******************** FETCH PROGRAM_SYSTEM TO EDIT ********************
export const fetchProgramSystem = (programId, { systemName }) => async (
	dispatch
) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_PROGRAM_SYSTEM_LOADING,
			payload: true
		});

		const { data } = await services.get(
			`/channel/programs/${programId}/systemFields?system=${systemName}`
		);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_PROGRAM_SYSTEM_SUCCESS,
			payload: data
		});
	} catch (error) {
		dispatch({
			type: types.FETCH_PROGRAM_SYSTEM_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};
